import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, Injector, Renderer2 } from "@angular/core";
import { MatTableDataSource, MatTableDataSourcePaginator } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { PVData } from "./cl-image-upload-table-data/cl-image-upload-table-data.component";
import moment from "moment";
import { BaseComponent } from "src/app/common/base/base.component";
import { ImageActionsIds } from "src/app/modules/libs/quill/quill-custom-image-resize/quill-custom-names";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { PVInfoService } from "src/app/services/pv-info/pv-info.service";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { ListImage, RadTableConfiguration, Spot, SpotOrigin } from "../cl-image-upload-content/cl-image-upload-content.component";
import { debounceTime, Subject } from "rxjs";
import { TableColumn } from "../cl-image-upload.component";

export interface MouseEvent {
  rowId: number;
  colId: number;
  cellsType: string;
}

@Component({
  selector: "cl-image-upload-table",
  templateUrl: "./cl-image-upload-table.component.html",
  styleUrls: ["./cl-image-upload-table.component.scss"],
})
export class ClImageUploadTableComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() disabled!: boolean;
  @Input() configuration?: RadTableConfiguration;
  @Input() compareConfiguration?: RadTableConfiguration;
  @Input() enableColumnsBuilder!: boolean;
  @Input() editor!: boolean;
  @Input() builder!: boolean;
  @Input() enableColumnsChecklist!: boolean;
  @Input() canEdit!: boolean;
  @Input() history?: boolean;

  @ViewChild("textarea") textarea!: ElementRef;
  @ViewChild('matTable') matTable?: ElementRef;

  @ViewChild('displayContainer', { static: true }) displayContainer?: ElementRef;
  @ViewChild('resizableElement', { static: true }) resizableElement?: ElementRef;

  @Output() newSpot = new EventEmitter<number>();
  @Output() rowDeleted = new EventEmitter<number>();
  @Output() spotDeleted = new EventEmitter<number>();
  @Output() tableChanged = new EventEmitter<RadTableConfiguration>();
  @Output() newRow = new EventEmitter<number>();
  @Output() setRow = new EventEmitter<any>();
  @Output() rowDuplicated = new EventEmitter<any>();
  @Output() channelsUpdated = new EventEmitter<PVData[]>();
  @Output() setLoading = new EventEmitter<boolean>();

  smallId: string = ImageActionsIds.smallId;
  fitId: string = ImageActionsIds.fitId;
  largeId: string = ImageActionsIds.largeId;

  data!: any;
  compare!: any;

  datasetExt: any[] = [];
  widths!: number[];

  currentRow = -1;
  currentColumn = -1;

  colWidths!: number[];
  colorize!: boolean;
  includeIM!: boolean;
  incIMPosition!: number;
  incChannels!: boolean;
  updating!: boolean;
  channelsUpdating!: number;
  spots!: Spot[];
  spotClasses = SpotClass;

  id?: number;

  tableClass?: string;

  public displayedColumns: TableColumn[] = [];
  public columns!: string[];
  public dataSource = new MatTableDataSource<any>();
  public IdSpotAdd = 0;

  selectedRowIndex!: number;

  tableMouseDown!: MouseEvent;
  tableMouseUp!: MouseEvent;
  isMobile!: boolean;
  FIRST_EDITABLE_ROW = 0;
  LAST_EDITABLE_ROW: number = this.dataSource.data.length - 1;
  FIRST_EDITABLE_COL = 1;
  LAST_EDITABLE_COL: number = this.displayedColumns.length - 1;
  newCellValue = "";

  editorText!: string;
  dragEnabled?: boolean;

  public columnInit: TableColumn[] = [
    { name: "id", label: "", width: 25, readOnly: true },
  ];
  public columnSpot: TableColumn[] = [
    { name: "spotid", label: "Spot", width: 25, readOnly: true },
  ];
  public columnActions: TableColumn[] = [
    { name: "actions", label: "", width: 25 },
  ];
  public columnData: TableColumn[] = [{ name: "data", label: "Data" }];
  public columnsBuilder!: TableColumn[];
  public columnsChecklist!: TableColumn[];

  columnsIntegratedMeasurements: TableColumn[] = [
    { name: "reading", label: "Int. Reading<br>[mR]", type: "group" },
    { name: "time", label: "Int. Time<br>[m]", type: "group" },
    {
      name: "calcdose",
      label: "Calculated Dose Rate<br>[mR/h]",
      type: "group",
    },
  ];

  dataset!: any[];

  private scrollTimeout: any;
  private scrollEvent?: () => void;
  private observer?: IntersectionObserver;
  private resizeObservers: ResizeObserver[] = [];
  private mutationObservers: MutationObserver[] = [];

  selectedCellsState: boolean[][] = [];
  selection = new SelectionModel<any[]>(true, []);
  enabled = true;
  images: ListImage[] = [];
  selectedRow: any;

  addingSpot?: boolean;
  showUpdateData!: boolean;

  tooltipMessage!: string;
  channelCopy!: PVData;
  imageMaxWidth = 500;
  imageSizes!: [{ name: 'Small'; val: 255; }, { name: 'Medium'; val: 400; }, { name: 'Original'; val: 0; }];
  quillConfig = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
        [{ script: 'sub' }, { script: 'super' }],      // superscript/subscript
        [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
        ['table'], // Add the table option to the toolbar
        ['link', 'image', 'video'],
        ['clean']
      ],
    },
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          handler: () => {
            return false;
          }
        },
        shiftEnter: {
          key: 13,
          shiftKey: true,
          handler: () => {
            return true;
          }
        },
        tab: {
          key: 9,
          handler: () => {
            return false;
          }
        }
      }
    },
    imageDrop: true,
    imageResize: true,
    customImageResize: true,
    imageCompressor: {
      quality: 0.3, // default
      maxWidth: this.imageMaxWidth, // default
      imageType: 'image/*', // default
      debug: true
    },
  };

  private textChangeSub: any;
  private textChange$ = new Subject<{
    e: KeyboardEvent;
    column: any;
    row: number;
    col: number;
  }>();

  private readonly fixedNonEditableColumns = new Set([
    'actions',
    'spotid',
    'id',
    'calcdose',
    'data'
  ]);

  private nonEditableColumns = new Set<string>();

  constructor(
    protected override injector: Injector,
    public sanitizer: DomSanitizer,
    private pvService: PVInfoService,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.createSelectedStates();
    this.id = this.utils.getRandomInt(1, 100);
    this.textChangeSub = this.textChange$
      .pipe(debounceTime(1000))
      .subscribe(({ e, column, row, col }) => {
        this.commitTextChange(e, column, row, col);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.disabled) { this.canEdit = false; }
    this.tableClass = this.history ? 'table-container-short' : 'table-container';
    this.renderTable();
    this.addingSpot = false;
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    // Clean up the observer when the component is destroyed
    if (this.scrollEvent) {
      this.scrollEvent();
    }

    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.textChangeSub?.unsubscribe();
    this.resizeObservers.forEach(observer => observer.disconnect());
    this.mutationObservers.forEach(observer => observer.disconnect());
  }

  private buildNonEditableColumns(): void {
    const builderNames = (this.columnsBuilder ?? [])
      .map(c => this.normalizeColumnName(c?.name))
      .filter((name): name is string => !!name);

    this.nonEditableColumns = new Set([
      ...this.fixedNonEditableColumns,
      ...builderNames
    ]);
  }

  private normalizeColumnName(value: string | null | undefined): string {
    if (!value) return '';

    return String(value)
      .replace(/<[^>]*>/g, '')   // remove HTML tags
      .replace(/&nbsp;/g, ' ')
      .trim()
      .toLowerCase();
  }

  renderTable(): void {
    if (!this.configuration) {
      return;
    }

    this.data = this.configuration;
    this.compare =
      this.compareConfiguration && this.history
        ? this.utils.cloneDeep(this.compareConfiguration)
        : null;

    this.columnsBuilder = this.configuration.columnsBuilder ?? [];
    this.columnsChecklist = this.configuration.columnsChecklist ?? [];
    this.images = this.configuration.images ?? [];
    this.colorize = this.configuration.colorize ?? false;
    this.includeIM = this.configuration.includeIM ?? false;
    this.incIMPosition = this.configuration.includeIMPos ?? 0;
    this.incChannels = this.configuration.channels ?? false;
    this.spots = this.configuration.spots ?? [];

    if (!this.incIMPosition) {
      this.incIMPosition = this.columnsChecklist.length;
    }

    const columns = this.buildColumns();
    const displayedColumns = columns.filter(
      column => column.name !== 'values' && column.name !== 'placeholder'
    );

    this.processData();
    this.markLastRows();

    this.columns = displayedColumns.map(column => column.name);
    this.displayedColumns = displayedColumns;
    this.dataSource = new MatTableDataSource(this.datasetExt);

    this.LAST_EDITABLE_ROW = this.configuration.data?.length ?? -1;
    this.LAST_EDITABLE_COL = columns.length;

    this.buildNonEditableColumns();
  }

  private buildColumns(): any[] {
    let columns = [
      ...this.columnInit,
      ...this.columnsBuilder,
      ...this.columnSpot,
    ];

    if (this.includeIM) {
      const checklistColumnsWithIM = this.utils.insertArrayAt(
        this.utils.cloneDeep(this.columnsChecklist),
        this.incIMPosition,
        this.columnsIntegratedMeasurements
      );

      columns = [...columns, ...checklistColumnsWithIM];
    } else {
      columns = [...columns, ...this.columnsChecklist];
    }

    if (this.incChannels) {
      const insertPosition = columns.some(column => column.name === 'notes')
        ? columns.length - 1
        : columns.length;

      columns = this.utils.insertArrayAt(
        this.utils.cloneDeep(columns),
        insertPosition,
        this.columnData
      );

      this.checkChannelData(this.configuration!);
    }

    return [...columns, ...this.columnActions];
  }

  private markLastRows(): void {
    const lastIndexById = new Map<any, number>();

    this.datasetExt.forEach((row, index) => {
      lastIndexById.set(row.id, index);
    });

    this.datasetExt.forEach((row, index) => {
      row.last = lastIndexById.get(row.id) === index;
    });
  }

  checkChannelData(configuration: RadTableConfiguration) {
    const data = this.pvDataRows(configuration);
    if (data.length) {
      const date = data.find((d) => d.date)?.date as Date;
      const sdate = moment(new Date(date)).format("LLL");
      this.tooltipMessage = date
        ? `Last update on <b class="b-500">${sdate}</b><br><small>Click to Update</small>`
        : "Click to get data";
    }
  }

  async updatePVData() {
    await this.getPVData().then((data: PVData[]) => {
      this.updateConfiguration(data);
      this.updating = false;
      this.tableChanged.emit(this.configuration);
    });
  }

  updateConfiguration(channels: PVData[]) {
    const rows = this.configuration?.data ?? [];
    rows.map((r: any) => {
      const data = this.utils.JSONparse(r.data) as PVData[];
      data?.map((c: PVData) => {
        const ch = channels.find((x) => x.name == c.name);
        c.date = ch?.date;
        c.value = ch?.value;
      });
      r.data = this.utils.JSONstringify(data);
    });
  }

  getPVData(): Promise<PVData[]> {
    return new Promise(async (resolve) => {
      const data = this.pvDataRows();
      if (!this.updating) {
        this.updating = true;
        data.map(async (c, i) => {
          c.error = false;
          c.updating = true;
          c.date = null;
          await this.updateChannel(c).then((channel: PVData) => {
            data[i] = channel;
            data[i].updating = false;
            if (!data.find((d) => !d.date)) {
              resolve(data);
            }
          });
        });
      }
    });
  }

  updateChannel(channel: PVData): Promise<PVData> {
    return new Promise((resolve, reject) => {
      channel.updating = true;
      this.pvService.getPVInfo(channel.name).subscribe(
        (data) => {
          const value = data.toString();
          if (value.includes("e")) {
            const e = value.split("e");
            channel.value =
              this.utils.roundNumber(e[0], 5) + " x 10<sup>" + e[1] + "</sup>";
          } else {
            channel.value = this.utils.roundNumber(value, 5);
          }
          if (!this.editor && !this.builder) {
            channel.date = new Date();
          }
          resolve(channel);
        },
        (error) => {
          console.log(error);
          channel.error = true;
          reject();
        }
      );
    });
  }

  pvDataRows(configuration?: RadTableConfiguration) {
    configuration = configuration
      ? configuration
      : this.configuration;
    const rows = configuration?.data ?? [];
    const data: PVData[] = [];
    rows.map((r: any) => {
      const rowData = this.utils.JSONparse(r.data);
      rowData?.map((d: any) => {
        data.push(d);
      });
    });
    return data;
  }

  rowSpan(column: any, item: any, row: any) {
    if (
      row % 1 == 0 ||
      column.name == "id" ||
      column.name == "spotid" ||
      column.name == "settings" ||
      column.name == "values"
    ) {
      if (column.name == "settings" || column.name == "values") {
        return 1;
      } else if (column.name == "id" || this.isBuilderColumn(column.name)) {
        return item.idSpan;
      } else if (
        column.name == "spotid" ||
        !this.isBuilderColumn(column.name)
      ) {
        return item.spotSpan;
      }
    }
    return 0;
  }

  isBuilderColumn(column: any): boolean {
    const colsBuilder: any[] = this.columnsBuilder.map((x) => x.name);
    return colsBuilder.includes(column);
  }

  columnValue(column: any, element: any): SafeHtml {
    if (column.name == "spotid") {
      let value = element[column.name];
      if (element[column.name]?.toString() === "0") {
        value = "";
      } else if (element.imageid) {
        if (Number(element.imageid) == 0) {
          value = 0;
        }
      }
      return this.sanitizer.bypassSecurityTrustHtml(value ?? '');
    } else {
      if (element[column.name])
        return this.sanitizer.bypassSecurityTrustHtml(element[column.name] ?? '');
      else return '';
    }
  }

  addSpot(e: any) {
    const row = this.dataSource.data.find((x) => x.rowId == e.rowId);
    this.setRow.emit(row);
  }

  cancelAddSpot() {
    this.IdSpotAdd = 0;
    this.addingSpot = false;
    this.newSpot.emit(0);
  }

  addRow(e: any) {
    this.newRow.emit(+e.id);
  }

  deleteSpot(e: any) {
    this.spotDeleted.emit(e);
  }

  deleteRow(e: any) {
    this.rowDeleted.emit(e);
  }

  duplicateRow(e: any) {
    this.rowDuplicated.emit(e);
  }

  // verifyActions(id: number): boolean {
  //   let value: boolean = true;
  //   if (this.configuration) {
  //     if (!this.images) {
  //       value = true;
  //       this.enabled = false;
  //     } else if (!this.images.length) {
  //       value = true;
  //       this.enabled = false;
  //     } else if (!this.IdSpotAdd) {
  //       value = false;
  //       this.enabled = true;
  //     } else {
  //       if (this.IdSpotAdd == id) {
  //         value = this.addingSpot ?? false;
  //         this.enabled = true;
  //       }
  //     }
  //   } else {
  //     value = true;
  //     this.enabled = true;
  //   }
  //   return value;
  // }

  setEditorSize() {
    if (this.textarea?.nativeElement) {
      this.textarea.nativeElement.style.minHeight =
        this.textarea.nativeElement.parentNode.clientHeight - 10 + "px";
    }
  }

  click(row: number, col: number, cellsType: string) {
    if (!this.disabled) {
      this.onMouseDown(row, col, cellsType);
      this.onMouseUp(row, col, cellsType);
    }
  }

  editorCreated(editor: any) {
    editor.focus();
    setTimeout(() => editor.setSelection(editor.getLength(), 0));
  }

  onMouseDown(row: number, col: number, cellsType: string) {
    let enableColums = true;
    const countBuilderColumn = this.columnsBuilder.filter(
      (x) => x.name == cellsType
    ).length;

    if (countBuilderColumn > 0) {
      if (
        this.enableColumnsBuilder == undefined ||
        this.enableColumnsBuilder == false
      ) {
        enableColums = false;
      }
    }
    if (enableColums && ((this.editor && !this.disabled) || (!this.builder && this.canEdit))) {
      if (
        cellsType != "actions" &&
        cellsType != "spotid" &&
        cellsType != "id" &&
        cellsType != "calcdose" &&
        cellsType != "data"
      ) {
        if (!this.selectedCellsState[row][col]) {
          this.tableMouseDown = { rowId: row, colId: col, cellsType };
          this.utils.removeExistingCustomContainers();
        } else {
          this.setEditorSize();
        }

        if (!(this.currentRow == row && this.currentColumn == col)) {
          if (this.currentColumn == -1 && this.currentRow == -1) {
            this.currentRow = row;
            this.currentColumn = col;
          } else {
            this.formatText(row, col);
            this.currentRow = row;
            this.currentColumn = col;
          }
        }
      }
    }
  }

  onMouseUp(row: number, col: number, cellsType: string) {
    let enableColums = true;
    const countBuilderColumn = this.columnsBuilder.filter(
      (x) => x.name == cellsType
    ).length;
    if (countBuilderColumn > 0) {
      if (
        this.enableColumnsBuilder == undefined ||
        this.enableColumnsBuilder == false
      ) {
        enableColums = false;
      }
    }

    if (enableColums) {
      if (
        cellsType != "actions" &&
        cellsType != "spotid" &&
        cellsType != "id" &&
        cellsType != "calcdose"
      ) {
        if (!this.selectedCellsState[row][col]) {
          this.tableMouseUp = { rowId: row, colId: col, cellsType };
          if (this.tableMouseDown) {
            this.newCellValue = "";
            this.updateSelectedCellsState(
              this.tableMouseDown.colId,
              this.tableMouseUp.colId,
              this.tableMouseDown.rowId,
              this.tableMouseUp.rowId
            );
            this.setEditorSize();
          }
          this.editorText =
            this.dataSource.data[row] && this.dataSource.data[row][cellsType]
              ? this.dataSource.data[row][cellsType]
              : "";
        }
      }
    }
  }

  formatText(row: any, col: any) {
    if (this.dataSource.data[row][col]) {
      if (col != "actions" && col != "spotid" && col != "id") {
        const valueCell = this.utils.replaceAll(
          this.utils.replaceAll(
            this.utils.replaceAll(
              this.utils.replaceAll(
                this.dataSource.data[row][col],
                "</p><p><br></p><p>",
                "<br><br>"
              ),
              "</p><p>",
              "<br>"
            ),
            "<p>",
            ""
          ),
          "</p>",
          ""
        );
        this.dataSource.data[row][col] = valueCell;
        // this.updateCellSelectedValue(row, col, valueCell);
      }
    }
  }

  createSelectedStates() {
    const cols = new Array(100).fill(false);
    for (let c = 0; c < 100; c++) {
      cols[c] = new Array(100).fill(false);
    }

    this.selectedCellsState = cols;
  }

  // updateCellSelectedValue(row: any, columName: any, valueCell: any) {
  //   if (this.isBuilderColumn(columName)) {
  //     const IdRow = this.dataSource.data[row].id;
  //     this.dataSource.data.map((item) => {
  //       if (item.id == IdRow) {
  //         item[columName] = valueCell;
  //       }
  //     });
  //   }
  // }

  updateSelectedCellsValues(text: string) {
    if (text == null) {
      return;
    }

    if (this.tableMouseDown && this.tableMouseUp) {
      if (this.tableMouseDown.cellsType === this.tableMouseUp.cellsType) {
        const dataCopy: any[] = this.dataSource.data.slice(); // copy and mutate
        let startCol: number;
        let endCol: number;
        let startRow: number;
        let endRow: number;

        if (this.tableMouseDown.colId <= this.tableMouseUp.colId) {
          startCol = this.tableMouseDown.colId;
          endCol = this.tableMouseUp.colId;
        } else {
          endCol = this.tableMouseDown.colId;
          startCol = this.tableMouseUp.colId;
        }

        if (this.tableMouseDown.rowId <= this.tableMouseUp.rowId) {
          startRow = this.tableMouseDown.rowId;
          endRow = this.tableMouseUp.rowId;
        } else {
          endRow = this.tableMouseDown.rowId;
          startRow = this.tableMouseUp.rowId;
        }

        // --Edit cells from the same column
        if (startCol === endCol) {
          console.log("--Edit cells from the same column");
          for (let i = startRow; i <= endRow; i++) {
            dataCopy[i][this.columns[startCol]] = text;
          }
        } else {
          // --Edit cells starting and ending not on the same column
          console.log(
            "--Edit cells starting and ending not on the same column"
          );

          for (let i = startRow; i <= endRow; i++) {
            for (let j = startCol; j <= endCol; j++) {
              dataCopy[i][this.columns[j]] = text;
            }
          }
        }
        console.log(
          "--update: " +
          startRow +
          ", " +
          startCol +
          " to " +
          endRow +
          ", " +
          endCol
        );
        this.dataSource = new MatTableDataSource(dataCopy);
      }
    }
  }

  private updateSelectedCellsState(
    mouseDownColId: number,
    mouseUpColId: number,
    mouseDownRowId: number,
    mouseUpRowId: number
  ) {
    // init selected cells
    for (let i = this.FIRST_EDITABLE_ROW; i <= this.LAST_EDITABLE_ROW; i++) {
      for (let j = this.FIRST_EDITABLE_COL; j <= this.LAST_EDITABLE_COL; j++) {
        this.selectedCellsState[i][j] = false;
      }
    }
    // update selected cells
    let startCol: number;
    let endCol: number;
    let startRow: number;
    let endRow: number;
    if (mouseDownColId <= mouseUpColId) {
      startCol = mouseDownColId;
      endCol = mouseUpColId;
    } else {
      endCol = mouseDownColId;
      startCol = mouseUpColId;
    }

    if (mouseDownRowId <= mouseUpRowId) {
      startRow = mouseDownRowId;
      endRow = mouseUpRowId;
    } else {
      endRow = mouseDownRowId;
      startRow = mouseUpRowId;
    }

    for (let i = startRow; i <= endRow; i++) {
      for (let j = startCol; j <= endCol; j++) {
        this.selectedCellsState[i][j] = true;
      }
    }
    // this.cdRef.detectChanges();
    this.setEditorSize();
  }

  textChanged(e: KeyboardEvent, column: any, row: number, col: number): void {

    switch (e.key) {

      case 'Enter':
        if (!e.shiftKey && !e.altKey) {
          e.preventDefault();
          this.moveDown(column, row, col);
        }
        break;

      case 'Tab':
        e.preventDefault();
        this.moveRight(column, row, col);
        break;

      // case 'ArrowUp':
      //   e.preventDefault();
      //   this.moveUp(column, row, col);
      //   break;

      // case 'ArrowDown':
      //   e.preventDefault();
      //   this.moveDown(column, row, col);
      //   break;

      // case 'ArrowLeft':
      //   e.preventDefault();
      //   this.moveLeft(column, row, col);
      //   break;

      // case 'ArrowRight':
      //   e.preventDefault();
      //   this.moveRight(column, row, col);
      //   break;

      case 'Escape':
        this.finalizeCellEdit(column, row, col);
        break;

      default:
        this.textChange$.next({ e, column, row, col });
        break;
    }
  }

  private commitTextChange(
    e: KeyboardEvent,
    column: any,
    row: number,
    col: number
  ): void {
    this.finalizeCellEdit(column, row, col, false);
  }

  private moveUp(column: any, row: number, col: number): void {

    if (row <= 0) return;

    this.setSelectedCell(row, col, false);

    this.currentRow = row - 1;
    this.currentColumn = col;

    this.setSelectedCell(this.currentRow, this.currentColumn, true);

    this.click(this.currentRow, this.currentColumn, column.name);
  }

  private moveDown(column: any, row: number, col: number): void {

    if (row >= this.LAST_EDITABLE_ROW - 1) return;

    this.setSelectedCell(row, col, false);

    this.currentRow = row + 1;
    this.currentColumn = col;

    this.setSelectedCell(this.currentRow, this.currentColumn, true);

    this.click(this.currentRow, this.currentColumn, column.name);
  }

  private moveRight(column: any, row: number, col: number): void {

    const nextCol = this.getNextEditableColumnIndex(col);
    if (nextCol === -1) return;

    this.setSelectedCell(row, col, false);

    this.currentRow = row;
    this.currentColumn = nextCol;

    this.setSelectedCell(this.currentRow, this.currentColumn, true);

    const columnName = this.displayedColumns[nextCol].name;

    this.click(this.currentRow, this.currentColumn, columnName);
  }

  private moveLeft(column: any, row: number, col: number): void {

    const prevCol = this.getPreviousEditableColumnIndex(col);
    if (prevCol === -1) return;

    this.setSelectedCell(row, col, false);

    this.currentRow = row;
    this.currentColumn = prevCol;

    this.setSelectedCell(this.currentRow, this.currentColumn, true);

    const columnName = this.displayedColumns[prevCol].name;

    this.click(this.currentRow, this.currentColumn, columnName);
  }

  private getPreviousEditableColumnIndex(currentCol: number): number {
    for (let i = currentCol - 1; i >= 0; i--) {
      const rawName = this.displayedColumns[i]?.name;
      const normalizedName = this.normalizeColumnName(rawName);

      if (normalizedName && !this.nonEditableColumns.has(normalizedName)) {
        return i;
      }
    }

    return -1;
  }

  private getNextEditableColumnIndex(currentCol: number): number {
    for (let i = currentCol + 1; i < this.displayedColumns.length; i++) {
      const rawName = this.displayedColumns[i]?.name;
      const normalizedName = this.normalizeColumnName(rawName);

      if (normalizedName && !this.nonEditableColumns.has(normalizedName)) {
        return i;
      }
    }

    return -1;
  }

  private setSelectedCell(row: number, col: number, selected: boolean): void {
    if (
      this.selectedCellsState?.[row] &&
      typeof this.selectedCellsState[row][col] !== 'undefined'
    ) {
      this.selectedCellsState[row][col] = selected;
    }
  }

  finalizeCellEdit(
    column: { name: string },
    row: number,
    col: number,
    resetSelection: boolean = true
  ): void {
    const columnName = column?.name;
    if (!columnName) return;

    const rowData = this.dataSource?.data?.[row];
    if (!rowData) return;

    const rawValue = rowData[columnName] ?? '';
    const cleanedValue = this.cleanEditableCellValue(String(rawValue));

    rowData[columnName] = cleanedValue;
    // this.updateCellSelectedValue(row, columnName, cleanedValue);
    this.emitTableChange();
    this.setFormDirty();

    if (resetSelection) {
      this.resetCurrentCellSelection(row, col);
    }
  }

  private emitTableChange(): void {
    this.configuration!.data = this.dataSource.data;
    this.tableChanged.emit(this.configuration);
  }

  private resetCurrentCellSelection(row: number, col: number): void {
    this.currentRow = -1;
    this.currentColumn = -1;

    if (
      this.selectedCellsState?.[row] &&
      typeof this.selectedCellsState[row][col] !== 'undefined'
    ) {
      this.selectedCellsState[row][col] = false;
    }
  }

  private cleanEditableCellValue(value: string): string {
    return value
      .replace(/<br><a id=.*?>Small<\/a> \| <a id=.*?>Fit<\/a> \| <a id=.*?>Original<\/a><br>/g, '')
      .replaceAll('</p><p><br></p><p>', '<br><br>')
      .replaceAll('</p><p>', '<br>')
      .replaceAll('<p>', '')
      .replaceAll('</p>', '');
  }


  channelsChanged(e: PVData[], column: any, row: any, col: any) {
    const newData = this.utils.JSONstringify(e);
    this.dataSource.data.forEach(d => {
      const data = this.utils.JSONparse(d.data) as PVData[];
      data.forEach(c => {
        const cc = e.find(x => x.name == c.name);
        if (cc) c.bookmarked = cc.bookmarked;
      });
      d.data = this.utils.JSONstringify(data);
    });
    if (!this.configuration) return;
    this.dataSource.data[row].data = newData;
    this.configuration.data = this.dataSource.data;
    this.tableChanged.emit(this.configuration);
    this.currentRow = -1;
    this.currentColumn = -1;
    this.selectedCellsState[row][col] = false;
  }

  mouseOut() {
    this.utils.removeExistingCustomContainers();
  }


  private processData() {
    const idSeen: any = {};
    const spotSeen: any = {};
    if (this.configuration) {
      const localdata = this.configuration.data;

      const dataSort = localdata?.sort((a, b) => {
        if (a.id == b.id) {
          const spota = +a.spotid?.toString().split(".")[1];
          const spotb = +b.spotid?.toString().split(".")[1];
          return spota - spotb;
        }
        return a.id > b.id ? 1 : -1;
      });
      let dataChanged = false;
      dataSort?.map((d) => {
        if (!d.rowId) {
          d.rowId = d.id + ".1";
          dataChanged = true;
        }
      });
      if (dataChanged) {
        this.tableChanged.emit(this.configuration);
      }
      if (dataSort)
        this.datasetExt = dataSort.map((item: any) => {
          const idSpan = idSeen[item.id] ? 0 : localdata?.filter((y) => y.id === item.id).length;
          idSeen[item.id] = true;
          spotSeen[item.id] = spotSeen[item.id] || {};
          spotSeen[item.id][item.spotid] = true;
          return { ...item, idSpan, spotSpan: 1 };
        });
    }
  }

  spotColor(e: any) {
    if (e.spotid) {
      const spot = this.spots.find((x) => x.spotText == e.spotid);
      return spot?.origin ? SpotClass.BLUE : SpotClass.RED;
    }
    return SpotClass.BLUE;
  }

  calculateDose(reading: string, time: string) {
    if (reading?.includes("^")) {
      reading = reading.replace("^", "e");
    }
    if (time?.includes("^")) {
      time = time.replace("^", "e");
    }
    const ntime = +this.utils.cleanHTML(time);
    const nreading = +this.utils.cleanHTML(reading);
    const calc = (nreading / ntime) * 60;
    // this.warnHigh = !isNaN(calc) && calc > 3.5;
    return isNaN(calc) ? "" : this.utils.roundNumber(calc, 5);
  }

  channelCopied(e: any) {
    this.channelCopy = e;
  }

  checkUpdatedTime(d: any) {
    const data = this.utils.JSONparse(d) as PVData[];
    const now = moment();
    return data.some(item => {
      const itemDate = moment(item.date);
      const timeDifference = Math.abs(itemDate.diff(now, 'seconds')); // Difference in seconds
      return timeDifference < 5;
    });
  }

  reorderTable(
    event: CdkDragDrop<MatTableDataSource<any, MatTableDataSourcePaginator>, any, any>,
    dataSource: MatTableDataSource<any>
  ) {
    if (this.editor) {
      dataSource.data = this.moveItemInArray(dataSource.data, event.previousIndex, event.currentIndex);
      dataSource.filter = "";
      if (!this.configuration) return;
      this.configuration.data = this.dataSource.data;
      let id = 0;
      let last = 0;
      this.dataSource.data.map(d => {
        if (d.id != last) {
          last = d.id;
          id++;
        }
        if (d.id != id) {
          d.id = id;
          const rowId = d.rowId.split('.')[1];
          d.rowId = d.id + '.' + rowId;
          if (d.spotid) {
            const spot = this.spots.find(s => s.spotText == d.spotid);
            const spotId = d.spotid.split('.')[1];
            d.spotid = id + '.' + spotId;
            if (spot) spot.spotText = d.spotid;
          }
        }
      });
      this.configuration.spots = this.spots;
      this.tableChanged.emit(this.configuration);
    }
  }

  moveItemInArray(data: any[], previousIndex: number, currentIndex: number) {
    const currentId = data[previousIndex].id;
    const targetId = data[currentIndex].id;

    // Filter out the items to be moved
    const itemsToMove = data.filter(item => item.id === currentId);
    // Filter out the items that will stay in place
    const itemsNotToMove = data.filter(item => item.id !== currentId);

    // Find the index where items with targetId end
    const targetIndex = currentIndex > previousIndex ? itemsNotToMove.map(item => item.id).lastIndexOf(targetId) + 1 : itemsNotToMove.map(item => item.id).indexOf(targetId);

    // Insert the itemsToMove after the items with targetId
    const result = [
      ...itemsNotToMove.slice(0, targetIndex),
      ...itemsToMove,
      ...itemsNotToMove.slice(targetIndex)
    ];

    return result;
  }

  getQuickValue(row: any, c: { name: string; label: string }): string {
    try {
      const v = (this as any).columnValue ? (this as any).columnValue(c, row) : row?.[c.name];
      return v ?? '';
    } catch {
      return '';
    }
  }

  compareData(row: number, column: any): boolean {
    if (!this.compare || !column?.name) return false;

    const colName = column.name;

    const currentRow = this.data?.data?.[row];
    const previousRow = this.compare?.data?.find((d: any) => d.rowId === currentRow?.rowId);

    if (!currentRow || !previousRow) return false;

    const currentValue = this.normalizeValue(currentRow[colName]);
    const previousValue = this.normalizeValue(previousRow[colName]);

    return currentValue !== previousValue;
  }

  private normalizeValue(value: any): any {
    if (value === null || value === undefined) return '';

    // Handle numbers stored as string vs number
    if (!isNaN(value) && value !== '') return Number(value);

    // Trim strings
    if (typeof value === 'string') return value.trim();

    return value;
  }

}

export enum SpotClass {
  RED = "red",
  BLUE = "blue",
}

